import { render } from 'react-dom';
import React from 'react';
import Raven from 'raven-js';

import App from 'src/app/App';
import environment from 'src/app/environment';
import errorTrackingConfiguration from 'src/app/errorLoggerConfiguration';

import 'src/assets/css/main.scss';


if (environment.production) {
  Raven
    .config('https://d506b805a1134d1281f8f68b8a604e2c@sentry.io/1186376', errorTrackingConfiguration)
    .install();
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // mute error from SW's registration due to sentry limits
    try {
      // eslint-disable-next-line compat/compat
      navigator.serviceWorker.register('sw.js');
    } catch (error) {
      //
    }
  });
}

render(<App />, document.getElementById('app'));
